export const authHeaders = (accessToken) => {
    return {
        headers: {
            Authorization: 'Bearer ' + accessToken,
        }
    };
};

